/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media only screen and (max-width:600px){.content[_ngcontent-%COMP%] > div.center[_ngcontent-%COMP%]{overflow:hidden!important;padding:8px!important}}"];
export { styles as styles };
